<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          最終進学先
        </SectionTitle>
        <router-link
          v-if="canEdit"
          :to="`/members/${userId}/profile/final_destination`"
          class="text-decoration-none">
          <icon-button
            class="ml-2"
            width="24"
            height="24"
            icon-size="18"
            icon="edit" />
        </router-link>
        <div
          v-if="finalDestination"
          class="ml-2 fs-s">
          更新日 {{ finalDestination.updatedAt | prettyDate }}
        </div>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <p class="fs-s pb-2">
        ※決定した進学先を入力・指導者も入力できます
      </p>
      <div
        class="bg-grey03 p-1"
        style="min-width: 200px; min-height: 32px; word-break: break-all;">
        {{ destinationName }}
      </div>
    </b-collapse>
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
export default {
  components: {
    IconButton,
    SectionTitle,
    CollapseButton,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    finalDestination: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
  computed: {
    destinationName() {
      return this.finalDestination?.destinationName || ''
    },
  },
}
</script>

<style>

</style>